module.exports = __webpack_public_path__ + "ba0b7a4098fc3892b263c81f1bb7bba0.png";